module.exports = __webpack_public_path__ + "img/banner.c7f9f688.svg";